import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Stack, Typography, Link} from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Zaloguj się</Typography>
        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2"> Nie masz jeszcze konta?</Typography>
          <Link to={PATH_AUTH.register} component={RouterLink} variant="subtitle2">
            Utworz konto
          </Link>
        </Stack>
      </Stack>
      <AuthLoginForm />
    </LoginLayout>
  );
}
